import React from 'react';
import {GraphNode, QueryNodeType} from '../../../../../../components/graph/interface';

export function useFilterNodesByType(type: QueryNodeType, nodesArray?: GraphNode[]) {
    return React.useMemo(
        () => nodesArray?.filter((node) => node.nodeType === type),
        [nodesArray, type]
    );
}
